import { imgUrl } from "../lib/api";

export default function DealerLogo({ dealer, size = "w-16 h-16", text = "text-2xl" }) {
  if (dealer?.logo_url) {
    return <img src={imgUrl(dealer.logo_url)} alt={dealer.name} className={`${size} rounded-2xl object-cover border border-[#D4AF37]/40 bg-black`} data-testid="dealer-logo" />;
  }
  const initials = (dealer?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <div className={`${size} rounded-2xl flex items-center justify-center border border-[#D4AF37]/50 bg-[#0b0c10]`} data-testid="dealer-logo">
      <span className={`font-display font-bold gold-text ${text}`}>{initials}</span>
    </div>
  );
}
